module.exports = __webpack_public_path__ + "static/media/Nio.3167cb9f.png";